import { AxiosInstance } from 'axios';

// Category slugs must match the EXCEPTION_VIEWS map on the backend.
export type ExceptionCategory =
  | 'metric-gaps'
  | 'attribute-gaps'
  | 'view-vs-pivot-formula-conflicts'
  | 'pivot-formula-conflicts'
  | 'renderer-conflicts'
  | 'label-conflicts';

export interface ExceptionSummary {
  'metric-gaps': number;
  'attribute-gaps': number;
  'view-vs-pivot-formula-conflicts': number;
  'pivot-formula-conflicts': number;
  'renderer-conflicts': number;
  'label-conflicts': number;
}

export interface ExceptionDetail {
  category: ExceptionCategory;
  view: string;
  count: number;
  // Row shape varies per category — see CATEGORY_META.columns for what
  // each view returns. Kept loose here so the grid can render whatever
  // arrives without ceremony.
  rows: Record<string, any>[];
}

export interface ExceptionFilters {
  view_name?: string;
  data_index?: string;
  nav_path_prefix?: string;
}

export const fetchExceptionSummary = async (
  api: AxiosInstance
): Promise<ExceptionSummary> => {
  const { data } = await api.get<ExceptionSummary>('/exceptions/summary');
  return data;
};

export const fetchExceptionCategory = async (
  api: AxiosInstance,
  category: ExceptionCategory,
  filters?: ExceptionFilters
): Promise<ExceptionDetail> => {
  const { data } = await api.get<ExceptionDetail>(
    `/exceptions/${category}`,
    { params: filters }
  );
  return data;
};
